import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

type Entity = models.EntregaIncompletaZEDTO;

export interface Props {
    value: Entity[];
}

/**Obtiene las columnas del grid */
function columnas(deps: {}): kea.Grid2Column<Entity>[] {
    return [
        { title: "Cliente", cell: x => ({ data: x.NombreCliente }) },
        { title: "Direccion", cell: x => ({ data: x.Direccion.Descripcion }) },
        { title: "Fecha", cell: x => ({ data: kea.toDate(x.FechaEntrega) }) },
    ];
}


/**
* Listado de EntregasIncompletas
*/
export class EntregasIncompletasList extends React.PureComponent<Props> {
    render() {
        const cols = columnas(this);
        return (
            <kea.Panel title="Entregas incompletas">
                <kea.Grid2 items={this.props.value} columnas={cols} hideBusqueda />
            </kea.Panel>
        );
    }
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/viajesZE/verificar/listas/incompletas.tsx